import React from 'react';
import { useLanguage } from '../../hooks/useLanguage';
import './languageSwitcher.scss';

export default function LanguageSwitcher() {
  const { lang, switchLanguage } = useLanguage();

  return (
    <button
      className="cs-lang_switcher"
      onClick={switchLanguage}
      title={lang === 'cs' ? 'Switch to English' : 'Přepnout do češtiny'}
      aria-label={lang === 'cs' ? 'Switch to English' : 'Přepnout do češtiny'}
    >
      <span className={lang === 'cs' ? 'active' : ''}>CZ</span>
      <span className="cs-lang_divider">/</span>
      <span className={lang === 'en' ? 'active' : ''}>EN</span>
    </button>
  );
}
